import { render } from "./EventHistoryPanel.vue?vue&type=template&id=7241fdba&scoped=true"
import script from "./EventHistoryPanel.vue?vue&type=script&lang=js"
export * from "./EventHistoryPanel.vue?vue&type=script&lang=js"

import "./EventHistoryPanel.vue?vue&type=style&index=0&id=7241fdba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7241fdba"]])

export default __exports__